module.exports = __webpack_public_path__ + "img/305.a5ae7a54.png";